export const addRanking = (ranking) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    
    if (
      !ranking.title ||
      !ranking.action ||
      !ranking.description ||
      !ranking.maxPercentage ||
      !ranking.minPercentage ||
      !ranking.selectedSchemes
    ) {
      dispatch({
        type: "ADDED_RANKING_ERROR",
        err: { message: "Input field required." },
      });
    } else {
      
      firestore
        .collection("ranking")
        .add({
          title: ranking.title,
          action: ranking.action,
          description: ranking.description,
          maxPercentage: ranking.maxPercentage,
          minPercentage: ranking.minPercentage,
          selectedSchemes: ranking.selectedSchemes,
        })
        .then((resp) => {
          dispatch({
            type: "ADDED_RANKING",
            message: "Ranking added successfully.",
            id: resp.id,
          });
        })
        .catch((err) => {
          dispatch({ type: "ADDED_RANKING_ERROR", err });
        });
    }
  };
};

export const updateRanking = (updatedRanking, rankingId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    if (
      !updatedRanking.title ||
      !updatedRanking.action ||
      !updatedRanking.description ||
      !updatedRanking.maxPercentage ||
      !updatedRanking.minPercentage ||
      !updatedRanking.selectedSchemes
    ) {
      dispatch({
        type: "UPDATED_RANKING_ERROR",
        err: { message: "Input field required." },
      });
    } else {

      firestore
        .collection("ranking")
        .doc(rankingId)
        .update({
          title: updatedRanking.title,
          action: updatedRanking.action,
          description: updatedRanking.description,
          maxPercentage: updatedRanking.maxPercentage,
          minPercentage: updatedRanking.minPercentage,
          selectedSchemes: updatedRanking.selectedSchemes,
        })
        .then(() => {
          dispatch({
            type: "UPDATED_RANKING",
            message: "Ranking updated successfully.",
          });
        })
        .catch((err) => {
          dispatch({ type: "UPDATED_RANKING_ERROR", err });
        });
    }
  };
};

export const deleteRanking = (rankingId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection("ranking")
      .doc(rankingId)
      .delete()
      .then(() => {
        dispatch({
          type: "DELETED_RANKING",
          message: "Ranking deleted successfully.",
        });
      })
      .catch((err) => {
        dispatch({ type: "DELETED_RANKING_ERROR", err });
      });
  };
};